module.exports = __webpack_public_path__ + "static/img/7106_phase_function_Paper_PointsHejduk_Prediction.8b45ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7106_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jCWX
// module chunks = 0